import { Component } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  tokens: any = 0;
  showUpgradeNotification: boolean = false;
  showLowTokenWarning: boolean = false;
  tier = '';
  private subscription: Subscription | undefined;

  constructor(private authService: AuthService) {}
  ngOnInit(): void {
    this.getTokenCount();
    this.subscription = interval(10000).subscribe(() => this.getTokenCount());
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getTokenCount(): void {
    console.log('APP Fetching token count...');
    this.authService.getDashboardStats().subscribe(
      (data) => {
        console.log('APP Token count fetched:', data);
        this.tokens = data.tokens;
        this.showLowTokenWarning = this.tokens < 100;
        this.showUpgradeNotification = this.tier === 'Essential';
      },
      (error) => {
        console.log('APP Error fetching token count:', error);
        document.location.href = 'https://queryai.co.uk';
      }
    );
  }
}
